module.exports = __webpack_public_path__ + "img/monthCard_btn.1cbc9e3d.png";